"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterpriseReportingProcessedRows_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EnterpriseReportingReport_1 = require("./EnterpriseReportingReport");
var EnterpriseReportingProcessedRows_Factory = /** @class */ (function () {
    function EnterpriseReportingProcessedRows_Factory() {
    }
    EnterpriseReportingProcessedRows_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            RecordId: model.RecordId,
            Report: EnterpriseReportingReport_1.EnterpriseReportingReport_Factory.CreateIncoming(model.Report),
            ReportId: model.ReportId,
            RowData: model.RowData,
        };
        return result;
    };
    EnterpriseReportingProcessedRows_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            RecordId: model.RecordId,
            Report: EnterpriseReportingReport_1.EnterpriseReportingReport_Factory.CreateOutgoing(model.Report),
            ReportId: model.ReportId,
            RowData: model.RowData,
        };
        return result;
    };
    return EnterpriseReportingProcessedRows_Factory;
}());
exports.EnterpriseReportingProcessedRows_Factory = EnterpriseReportingProcessedRows_Factory;
